import { THEME_PREFS, useTheme, type ThemePref } from '../theme'
import { Icon, type IconName } from './primitives'

// The design has no appearance control outside its Tweaks panel; these reuse
// its top-bar icon button (mobile) and segmented control (desktop).

const ICON: Record<ThemePref, IconName> = { auto: 'auto', light: 'sun', dark: 'moon' }
const LABEL: Record<ThemePref, string> = { auto: 'Auto', light: 'Light', dark: 'Dark' }

// Mobile: one button that cycles Auto → Light → Dark.
export function ThemeButton() {
  const { pref, setPref } = useTheme()
  const next = THEME_PREFS[(THEME_PREFS.indexOf(pref) + 1) % THEME_PREFS.length]
  return (
    <button
      className="icbtn"
      aria-label={`Appearance: ${pref}`}
      title={`Appearance: ${LABEL[pref]}`}
      onClick={() => setPref(next)}
      data-testid="theme-toggle"
    >
      <Icon name={ICON[pref]} size={20} />
    </button>
  )
}

// Desktop: Auto / Light / Dark segments.
export function ThemeSeg() {
  const { pref, setPref } = useTheme()
  return (
    <div className="seg" role="group" aria-label="Appearance" data-testid="theme-toggle">
      {THEME_PREFS.map((p) => (
        <button key={p} className={pref === p ? 'active' : ''} aria-pressed={pref === p} onClick={() => setPref(p)}>
          {LABEL[p]}
        </button>
      ))}
    </div>
  )
}
